module.exports = __webpack_public_path__ + "static/media/pfeil_gelb.76f1232b.png";